import {  COMMENT_FLAG, FULL_FEEDBACK } from '../types';

const initialState = {
  isLoading: false,
  messageStatus: COMMENT_FLAG.All,
  list: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  pages: 10,
  details: {},
  existFeedback: 0, // 是否存在未讀
  isOpenFeedbackForm: false, //
  isOpenFeedbackList: false,
  isOpenFeedbackDetails: false,
  isOpenEvaluation: false, // 給予評價
};

const feedbackReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_FEEDBACK.FormDrawer: {
      return {
        ...state,
        isOpenFeedbackForm: action.payload
      };
    }
    case FULL_FEEDBACK.ListDrawer: {
      return {
        ...state,
        isOpenFeedbackList: action.payload
      };
    }
    case FULL_FEEDBACK.DetailsDrawer: {
      return {
        ...state,
        isOpenFeedbackDetails: action.payload
      };
    }
    case FULL_FEEDBACK.Value: {
      return {
        ...state,
        messageStatus: action.payload
      };
    }
    case FULL_FEEDBACK.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_FEEDBACK.List: {
      return {
        ...state,
        ...action.payload
        // list
        // total
      };
    }
    case FULL_FEEDBACK.UnreadTotal: {
      return {
        ...state,
        existFeedback: action.payload
      };
    }
    case FULL_FEEDBACK.Details: {
      return {
        ...state,
        details: action.payload
      };
    }
    case FULL_FEEDBACK.Type: {
      return {
        ...state,
        options: action.payload
      };
    }
    case FULL_FEEDBACK.Rating: {
      return {
        ...state,
        ratings: action.payload
      };
    }
    case FULL_FEEDBACK.EvaluationDrawer: {
      return {
        ...state,
        isOpenEvaluation: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default feedbackReducer;
